import React, { useEffect, useState } from "react";
import Hero from "../components/Layout/Hero";
import { Link } from "react-router-dom";


import GenderCollectionSection from "../components/Products/GenderCollectionSection";
import NewArrivals from "../components/Products/NewArrivals";
import OversizedHoodieBanner from "../components/Layout/OversizedHoodieBanner";
import OverSizedHoodieTxt from "../components/Layout/OverSizedHoodieTxt";
// OverSized TShirt
import OverSizedTshirtTxt from "../components/Layout/OverSizedTshirtTxt";
import OverSizedTshirtBanner from "../components/Layout/OverSizedTshirtBanner";
import FeaturedOverSizedTshirt from "../components/Layout/FeaturedOverSizedTshirt";
// OverSized Shirt
import OverSizedShirtBanner from "../components/Layout/OverSizedShirtBanner";
import FeaturedOverSizedShirt from "../components/Layout/FeaturedOverSizedShirt";
// Tie-Dye
import TieDyeBanner from "../components/Layout/TieDyeBanner";
import FeaturedTieDye from "../components/Layout/FeaturedTieDye";
// Acid Washed
import AcidWashedBanner from "../components/Layout/AcidWashedBanner";
import FeaturedAcidwashed from "../components/Layout/FeaturedAcidwashed";
//Bottomwear
import BottomsBanner from "../components/Layout/BottomsBanner";
import FeaturedBottoms from "../components/Layout/FeaturedBottoms";
// Caps
import CapBanner from "../components/Layout/CapBanner";
import FeaturedCaps from "../components/Layout/FeaturedCaps";
// Winter Wear
import FeaturedWinterwear from "../components/Layout/FeaturedWinterwear";

import ProductDetails from "../components/Products/ProductDetails";
import FeaturesSection from "../components/Products/FeaturesSection";

import { useDispatch, useSelector } from "react-redux";
import { fetchProductsByFilters } from "../../redux/slices/productsSlice";
import axios from "axios";

const Home = () => {
  const dispatch = useDispatch();
  const { products, loading, error } = useSelector((state) => state.products);
  const [bestSellerProduct, setBestSellerProduct] = useState(null);

  useEffect(() => {
    dispatch(
      fetchProductsByFilters({
        gender: "Unisex",
        category: "Essentials",
        limit: 8,
      })
    );

    const fetchBestSeller = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_BACKEND_URL}/api/products/best-seller`
        );
        setBestSellerProduct(response.data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchBestSeller();
  }, [dispatch]);

  return (
    <div>
      <Hero />
      <GenderCollectionSection />
      <NewArrivals />

      

      {/* <h2 className="text-3xl text-center font-bold mb-4">Best Seller</h2>

      {bestSellerProduct ? (
        <ProductDetails productId={bestSellerProduct._id} />
      ) : (
        <p className="text-center">Loading Best Seller Product ... </p>
      )} */}

      {/* <OverSizedTshirtTxt />
      <OverSizedTshirtBanner /> */}
      <FeaturedOverSizedTshirt />

      {/* <OverSizedShirtBanner /> */}
      <FeaturedOverSizedShirt />

      {/* <TieDyeBanner /> */}
      <FeaturedTieDye />

      {/* <AcidWashedBanner /> */}
      <FeaturedAcidwashed />

      {/* <BottomsBanner /> */}
      <FeaturedBottoms />

      {/* <CapBanner /> */}
      <FeaturedCaps />
      
            <OverSizedHoodieTxt />
      <OversizedHoodieBanner />
      <FeaturedWinterwear />

      {/* ===================== COLLECTION GRID ===================== */}

      <div className="container mx-auto px-4 py-16">

        {/* Heading */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-black tracking-wider uppercase mb-4">
            Explore Our Collections
          </h2>
          <p className="text-sm tracking-wide">
            Curated pieces for those who refuse to follow
          </p>
        </div>

        {/* DESKTOP LAYOUT – 2 images in first row, 3 images in second row */}
        <div className="hidden md:block max-w-7xl mx-auto">
          
          {/* FIRST ROW – 2 images */}
          <div className="grid grid-cols-2 gap-6 mb-6">
            <Link to="/collections/all">
            <img
              src="https://res.cloudinary.com/dmrlotfsv/image/upload/t_VESHH-EON_WEBSITE/L1_icgqu3"
              className="w-full object-contain"
              loading="lazy"
            />
            </Link>
            
            <Link to="/collections/WinterWear">
            <img
              src="https://res.cloudinary.com/dmrlotfsv/image/upload/t_VESHH-EON_WEBSITE/L2_t3hhbt"
              className="w-full object-contain"
              loading="lazy"
            />
            </Link>
          </div>

          {/* SECOND ROW – 3 images */}
          <div className="grid grid-cols-3 gap-6">
            <Link to="/collections/OverSized%20T-Shirt">
            <img
              src="https://res.cloudinary.com/dmrlotfsv/image/upload/t_VESHH-EON_WEBSITE/L3_xsruss"
              className="w-full object-contain"
              loading="lazy"
            />
            </Link>

            <Link to="/collections/Concrete%20Jungle">
            <img
              src="https://res.cloudinary.com/dmrlotfsv/image/upload/t_VESHH-EON_WEBSITE/L4_noq76r"
              className="w-full object-contain"
              loading="lazy"
            />
            </Link>

            <Link to="/collections/Extras">
            <img
              src="https://res.cloudinary.com/dmrlotfsv/image/upload/t_VESHH-EON_WEBSITE/L5_jl8l2y"
              className="w-full object-contain"
              loading="lazy"
            />
            </Link>
          </div>
        </div>

        {/* MOBILE LAYOUT – asymmetric stacked */}
        <div className="md:hidden grid grid-cols-2 gap-4">

          {/* COLUMN 1 – 2 images */}
          <div className="space-y-4">
            <Link to="/collections/all">
            <img
              src="https://res.cloudinary.com/dmrlotfsv/image/upload/t_VESHH-EON_WEBSITE/S1_f18yqz"
              className="w-full object-contain"
              loading="lazy"
            />
            </Link>

            <Link to="/collections/WinterWear">
            <img
              src="https://res.cloudinary.com/dmrlotfsv/image/upload/t_VESHH-EON_WEBSITE/S2_xmlpie"
              className="w-full object-contain mt-10"
              loading="lazy"
            />
            </Link>
          </div>

          {/* COLUMN 2 – 3 images */}
          <div className="space-y-4">
            <Link to="/collections/OverSized%20T-Shirt">
            <img
              src="https://res.cloudinary.com/dmrlotfsv/image/upload/t_VESHH-EON_WEBSITE/S3_znyrvq"
              className="w-full object-contain"
              loading="lazy"
            />
            </Link>

            <Link to="/collections/Concrete%20Jungle">
            <img
              src="https://res.cloudinary.com/dmrlotfsv/image/upload/t_VESHH-EON_WEBSITE/S4_zqg9n3"
              className="w-full object-contain"
              loading="lazy"
            />
            </Link>

            <Link to="/collections/Extras">
            <img
              src="https://res.cloudinary.com/dmrlotfsv/image/upload/t_VESHH-EON_WEBSITE/S5_ah6jhq"
              className="w-full object-contain"
              loading="lazy"
            />
            </Link>
          </div>
        </div>
      </div>

      <FeaturesSection />
    </div>
  );
};

export default Home;
